<template>
  <div v-loading="loading" style="min-height: 150px">
    <template v-if="addressList.length">
      <div v-for="(address, index) in addressList" :key="address.rid || index" class="address-section">
        <p class="address-info">
          <label>配送至：</label>
          <span>{{ address.rfullAddress }} {{ address.rreceiveUserName }} {{ address.rreceiveTel }}</span>
        </p>
        <el-table
          :data="address.contractProductList"
          border
          style="width: 100%"
          :summary-method="getSummaries"
          show-summary
        >
          <el-table-column type="index" width="70" label="序号" align="left" fixed="left" />
          <el-table-column prop="rproductCode" label="销售产品代码" align="left" min-width="120" />
          <el-table-column prop="rproductInvoiceName" label="商品名称" align="left" min-width="150" />
          <el-table-column prop="rproductName" label="规格型号" align="left" min-width="150" />
          <el-table-column prop="rproductNum" label="数量" align="right" header-align="left" width="70" />
          <el-table-column prop="rmaterialUnit" label="单位" align="left" width="80" />
          <el-table-column prop="rafterSplitPrice" label="单价" align="right" header-align="left" width="100" />
          <el-table-column prop="rproductPriceAdd" label="订单金额" align="right" header-align="left" width="110" />
          <el-table-column prop="rbeforeSplitPrice" label="拆分前单价" align="right" header-align="left" width="100" />
          <el-table-column prop="rproductActualPriceAdd" label="实际结算金额" align="right" header-align="left" width="120" />
          <el-table-column label="是否购买PSC" align="left" width="100">
            <template v-slot="{ row }">
              {{ formatBoolean(row.risBuyPsc) }}
            </template>
          </el-table-column>
          <el-table-column label="是否冲销" align="left" width="80">
            <template v-slot="{ row }">
              {{ formatBoolean(row.risBorrowToSale) }}
            </template>
          </el-table-column>
          <el-table-column prop="rexpectedDeliveryDate" label="期望发货日期" align="left" width="110">
            <template v-slot="{ row }">
              {{ formatDate(row.rexpectedDeliveryDate) }}
            </template>
          </el-table-column>
          <el-table-column prop="taxName" label="税收分类名称" align="left" min-width="120" />
          <el-table-column prop="taxRate" label="税率" align="right" header-align="left" width="70">
            <template v-slot="{ row }">
              {{ formatTaxRate(row.taxRate) }}
            </template>
          </el-table-column>
          <el-table-column prop="rconfigInfo" label="产品配置描述" align="left" min-width="140" />
          <el-table-column prop="rservicedesc" label="服务备注" align="left" min-width="120" />
        </el-table>
      </div>
    </template>
    <el-empty v-else-if="!loading" description="暂无换货产品" :image-size="80" />
  </div>
</template>

<script type="es6">
import { getChangeContractInfoByOldContractNum } from '@/API';
import { MathAdd } from '@/libs/util';

export default {
  props: {
    contractNum: {
      type: [String, Number],
      required: true
    }
  },
  data () {
    return {
      addressList: [],
      loading: false
    };
  },
  watch: {
    contractNum: {
      immediate: true,
      handler () {
        this.initData();
      }
    }
  },
  methods: {
    initData () {
      if (!this.contractNum) return;
      this.loading = true;
      getChangeContractInfoByOldContractNum(this.contractNum).then((res) => {
        const { status, data } = res.data;
        if (status === '200') {
          this.addressList = data || [];
        } else {
          this.addressList = [];
        }
      }).catch(() => {
        this.addressList = [];
      }).finally(() => {
        this.loading = false;
      });
    },
    getSummaries ({ columns, data }) {
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
        } else if (['数量', '订单金额', '实际结算金额'].includes(column.label)) {
          sums[index] = data.reduce((total, item) => MathAdd(total, item[column.property] || 0), 0);
        } else {
          sums[index] = '';
        }
      });
      return sums;
    },
    formatBoolean (value) {
      if (value === true || value === 1 || value === '1' || value === 'Y') return '是';
      if (value === false || value === 0 || value === '0' || value === 'N') return '否';
      return '';
    },
    formatDate (value) {
      return value ? String(value).slice(0, 10) : '';
    },
    formatTaxRate (value) {
      return value ? `${value}` : '';
    }
  }
};
</script>

<style lang="scss" scoped>
.address-section {
  margin-bottom: 16px;
}

.address-info {
  margin: 0 0 12px;
}
</style>
